import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FaSignOutAlt, FaUser, FaBars } from 'react-icons/fa';

const AdminHeader = ({ onToggleCollapse, collapsed }) => {
  const { user, logout } = useAuth();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="px-6 py-4 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <button
            onClick={onToggleCollapse}
            className="p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100"
          >
            <FaBars size={20} />
          </button>
          <h1 className="text-xl font-semibold text-gray-800">
            EFIS Administration
          </h1>
        </div>

        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center text-white">
              <FaUser size={14} />
            </div>
            <div className="hidden md:block">
              <p className="text-sm font-medium text-gray-700">{user?.username || 'Admin'}</p>
              <p className="text-xs text-gray-500">Administrator</p>
            </div>
          </div>
          
          <button
            onClick={logout}
            className="p-2 rounded-md text-gray-500 hover:text-red-600 hover:bg-red-50 transition"
            title="Logout"
          >
            <FaSignOutAlt size={18} />
          </button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;